import { Injectable } from "@angular/core";
import { ChecklistStateStore } from "./checklist-state.store";
import { select } from "@ngneat/elf";

@Injectable({ providedIn: "root" })
export class ChecklistStateQuery {
	constructor(private checklistStateStore: ChecklistStateStore) {}

	preopeningChecklistSubmitted$ = this.checklistStateStore.store.pipe(
		select((state) => state.preopeningChecklistSubmitted),
	);
}
